import '../../sass/pages/_activities.scss'
let tags: any = ''

declare global {
    interface Window {
        dataLayer: any
    }
}

document.addEventListener('DOMContentLoaded', (event) => {
    getActivitiesInitial()
    filterActivities()
    checkboxFinishedActivitiesFilter()
    showFilter()
    cancelFilter()
    cleanFiltersBox()
    cleanAllFilters()
    searchFu()
    enterSearchActivities()
})


// Function para ejecutar los filtros

const filterActivities = () => {
    let form = document.getElementById('formFilter') as HTMLFormElement
    form?.addEventListener('submit', event => {
        event.preventDefault();
        const formData: any = new FormData(form)
        //const temp = new URLSearchParams(formData)
        const temp = Object.fromEntries(formData)
        tags = Object.fromEntries(formData)
        renderTagsFilters(tags)
        filterActivitiesPet(temp)
    })
}

// Function Obtiene la data para las actividades en la primera carga

const getActivitiesInitial = async () => {
    let url = '/get/actividades/'
    try {
        let info = {
            finalizada: '',
            causa: '',
            estado: '',
            voluntario: '', // Virtual or Presencial
        }
        let res = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info)
        })
        const data = await res.json();
        const qtyEl = data.total
        const perPage = data.pagina
        await renderActivities(data.response)
        await loadMore(qtyEl, perPage)
        await showNoResultsMessage(data.response)

    } catch (error) {
        console.log(error)
    }
}


// Function para el endpoint cuando se utilizan los filtros

const filterActivitiesPet = async (temp: any) => {
    let url = '/get/actividades/'
    try {
        let res = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(temp)
            //body:temp
        })
        const data = await res.json();
        const qtyEl = data.total
        const perPage = data.pagina
        await renderActivities(data.response)
        await loadMore(qtyEl, perPage)
        await showNoResultsMessage(data.response)

    } catch (error) {
        console.log(error)
    }
}


// Function REnderiza los tags de los filtros que el usuario selecciono

const renderTagsFilters = (tags: any) => {
    if (tags.hasOwnProperty('finalizada')) {
        tags.finalizada = 'Finalizada'
    }
    let tagsValue = Object.values(tags)
    let container = document.querySelector('.mvm__activities__container__filters__tags__box') as HTMLElement
    let cleanAll = document.querySelector('.mvm__activities__container__filters__clean')
    let form = document.getElementById('formFilter') as HTMLFormElement
    let filters = document.querySelector('.mvm__filters') as any
    let label = document.querySelector('.mvm__filters__form__slide__box p') as HTMLElement
    if (Object.keys(tags).length) {
        cleanAll?.classList.add('mvm__activities__container__filters__clean--active')
    } else {
        cleanAll?.classList.remove('mvm__activities__container__filters__clean--active')
    }
    container.innerHTML = ''
    tagsValue.map((tag: any, i) => {
        let box = document.createElement('li')
        box.className = 'mvm__activities__container__filters__tags__tag'
        let nameTag = document.createElement('p') as any
        nameTag.textContent = tag
        let deleteBtn = document.createElement('span')
        deleteBtn.textContent = 'x'
        deleteBtn.addEventListener('click', e => {
            let parent = deleteBtn?.parentNode as any
            parent?.remove()
            tag = null
            tagsValue.splice(i, 1)
            //delete tag
            setTimeout(() => {
                if (tagsValue.length === 0) {
                    cleanAll?.classList.remove('mvm__activities__container__filters__clean--active')
                    label?.classList.remove('active')
                    form?.reset()
                    if (filters != undefined) {
                        filters.style.height = `0px`
                        filters?.classList.remove('mvm__filters--active')
                    }
                    getActivitiesInitial()
                }
            }, 1000);
        })
        box.appendChild(nameTag)
        box.appendChild(deleteBtn)
        container.appendChild(box)
    })
}



// Function Actividad finalziad cuando esta activo agrega clase para poner color rojo en el label

const checkboxFinishedActivitiesFilter = () => {
    let checkbox = document.getElementById('finishedActivities') as HTMLElement
    let label = document.querySelector('.mvm__filters__form__slide__box p') as HTMLElement
    checkbox?.addEventListener('change', e => {
        label?.classList.toggle('active')
    })
}

// Function Show Filter

const showFilter = () => {
    let btnFilter = document.querySelector('.mvm__activities__container__filters__filter');
    let filters = document.querySelector('.mvm__filters') as any;
    let container = document.querySelector('.mvm__filters__form') as any
    let heCont = container?.offsetHeight
    btnFilter?.addEventListener('click', e => {
        if (filters != undefined) {
            filters.style.height = `${heCont}px`
            filters?.classList.add('mvm__filters--active')
        }
    })
}

// Function Cancel Filters

const cancelFilter = () => {
    let btnClear = document.getElementById('cancelFilters');
    let form = document.getElementById('formFilter') as HTMLFormElement
    let filters = document.querySelector('.mvm__filters') as any
    let label = document.querySelector('.mvm__filters__form__slide__box p') as HTMLElement
    btnClear?.addEventListener('click', e => {
        e.preventDefault()
        label?.classList.remove('active')
        form?.reset()
        if (filters != undefined) {
            filters.style.height = `0px`
            filters?.classList.remove('mvm__filters--active')
        }
        getActivitiesInitial()
    })
}

// Function Clean Filter Box

const cleanFiltersBox = () => {
    let cleanBtn = document.getElementById('cleanFilters')
    let form = document.getElementById('formFilter') as HTMLFormElement
    let label = document.querySelector('.mvm__filters__form__slide__box p') as HTMLElement
    cleanBtn?.addEventListener('click', e => {
        let tagsEl = Array.from(document.querySelectorAll('.mvm__activities__container__filters__tags__tag'))
        if (tagsEl.length > 0) {
            tagsEl.map(tag => {
                tag.parentNode?.removeChild(tag)
            })
            tags = {}
        }
        label?.classList.remove('active')
        form?.reset()
        getActivitiesInitial()
    })
}


// Function Clean All Filters

const cleanAllFilters = () => {
    let cleanAll = document.querySelector('.mvm__activities__container__filters__clean')
    let form = document.getElementById('formFilter') as HTMLFormElement
    let filters = document.querySelector('.mvm__filters') as any
    let label = document.querySelector('.mvm__filters__form__slide__box p') as HTMLElement
    cleanAll?.addEventListener('click', e => {
        e.preventDefault()
        let tagsEl = Array.from(document.querySelectorAll('.mvm__activities__container__filters__tags__tag'))
        if (tagsEl.length > 0) {
            tagsEl.map(tag => {
                tag.parentNode?.removeChild(tag)
            })
            tags = {}
        }
        label?.classList.remove('active')
        cleanAll?.classList.remove('mvm__activities__container__filters__clean--active')
        form?.reset()
        if (filters != undefined) {
            filters.style.height = `0px`
            filters?.classList.remove('mvm__filters--active')
        }
        getActivitiesInitial()
    })
}



// Function search

const searchFu = async () => {
    let searchField = document.getElementById('searchField') as any
    let searchBtn = document.getElementById('searchBtn')
    window.dataLayer = window.dataLayer || [];
    const containerActivities = document.querySelector('.mvm__activities__container__layout') as HTMLElement;
    searchBtn?.addEventListener('click', async e => {
        e.preventDefault()
        window.dataLayer.push({
            'event': 'GAEvent',
            'event_category': 'Actividades',
            'event_action': 'button',
            'event_label': 'Buscar',
            'interaction': 'true',
            'component_name': 'button_Buscar',
            'element_text': 'Buscar'
        });
        let value = searchField?.value.toLowerCase()
        let activities = await getActivitiesBySearch()
        const result = await activities.filter((activity: any) => {
            let nombreRest = activity.nombre.toLowerCase()
            if (nombreRest.includes(value)) return activity
        })
        renderActivities(result)
        showNoResultsMessage(result)
        loadMore(result.length, 6)
    })
}


const getActivitiesBySearch = async () => {
    let url = '/get/actividades/'
    try {
        let info = {
            finalizada: '',
            causa: '',
            estado: '',
            voluntario: '', // Virtual or Presencial
        }
        let res = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(info)
        })
        const data = await res.json();
        return data.response

    } catch (error) {
        console.log(error)
    }
}


// Function Pinta las cards de las actividades una vez es consumido el endpoint

const renderActivities = async (data: any) => {
    let _activities = await data;
    const containerActivities = document.querySelector('.mvm__activities__container__layout') as HTMLElement;
    containerActivities.innerHTML = ''
    _activities.forEach((element: any, index: any) => {
        const activityElement = document.createElement('a');
        activityElement.href = element.url_activity;
        activityElement.classList.add('mvm__activity');

        const imageElement = document.createElement('img');
        imageElement.classList.add('mvm__activity-image');
        imageElement.src = element.imagen;
        imageElement.alt = '';
        activityElement.appendChild(imageElement);

        const titleElement = document.createElement('h2');
        titleElement.classList.add('subtitleSmall');
        titleElement.textContent = element.nombre;
        activityElement.appendChild(titleElement);

        const infoElement = document.createElement('div');
        infoElement.classList.add('mvm__activity-info');

        const causeElement = document.createElement('p');
        causeElement.classList.add('black_22');
        causeElement.textContent = element.causa;
        infoElement.appendChild(causeElement);

        const stateElement = document.createElement('p');
        stateElement.classList.add('medium_22');
        stateElement.textContent = element.estado;
        infoElement.appendChild(stateElement);

        activityElement.appendChild(infoElement);

        const datesElement = document.createElement('div');
        datesElement.classList.add('mvm__activity-dates');

        const startElement = document.createElement('div');
        startElement.classList.add('mvm__activity-start');

        const startDateLabel = document.createElement('div');
        startDateLabel.classList.add('medium_18');
        startDateLabel.textContent = 'Fecha de inicio';
        startElement.appendChild(startDateLabel);

        const startDate = document.createElement('div');
        startDate.classList.add('date', 'black_22');
        startDate.textContent = element.start_date;
        startElement.appendChild(startDate);

        const startTime = document.createElement('div');
        startTime.classList.add('hour', 'black_22');
        startTime.textContent = element.start_time;
        startElement.appendChild(startTime);

        datesElement.appendChild(startElement);

        if (element.end_date !== '' && element.end_time !== '') {
            const endElement = document.createElement('div');
            endElement.classList.add('mvm__activity-end');

            const endDateLabel = document.createElement('div');
            endDateLabel.classList.add('medium_18');
            endDateLabel.textContent = 'Fecha de finalización';
            endElement.appendChild(endDateLabel);

            const endDate = document.createElement('div');
            endDate.classList.add('date', 'black_22');
            endDate.textContent = element.end_date;
            endElement.appendChild(endDate);

            const endTime = document.createElement('div');
            endTime.classList.add('hour', 'black_22');
            endTime.textContent = element.end_time;
            endElement.appendChild(endTime);

            datesElement.appendChild(endElement);
        }

        activityElement.appendChild(datesElement);

        const btnElement = document.createElement('div');
        btnElement.classList.add('btn--transparent');
        btnElement.textContent = 'Ver Más';
        activityElement.appendChild(btnElement);

        containerActivities.appendChild(activityElement);

    })
    containerActivities.addEventListener('click', function (e: any) {
        let target = e.target
        let title : any;
        window.dataLayer = window.dataLayer || [];
        if (target.classList.contains('mvm__activity') || target.classList.contains('btn--transparent')) {
            if(target.classList.contains('mvm__activity')){
                title = target.querySelector('.subtitleSmall')
            }else if(target.classList.contains('btn--transparent')){
                title = target.parentNode.querySelector('.subtitleSmall')
            }
            window.dataLayer.push({
                'event': 'GAEvent',
                'event_category': 'Actividades',
                'event_action': 'button',
                'event_label': `${title.innerHTML}`,
                'interaction': 'true',
                'component_name': 'button_Ver más',
                'element_text': 'Ver más'
            });
        }
    })


}


// Function Load More

const loadMore = async (qtyEl: any, perPage: any) => {
    let loadMore = document.getElementById('loadMoreActivities')
    let activities = await Array.from(document.querySelectorAll('.mvm__activity'))
    if (qtyEl > perPage) {
        loadMore?.classList.add('active')
    } else {
        loadMore?.classList.remove('active')
    }
    activities.forEach((box: any, index) => {
        if (index >= perPage) {
            box.style.display = "none";
        }
    })
    loadMore?.addEventListener('click', e => {
        e.preventDefault()
        perPage += 6
        activities.forEach((box: any, index) => {
            if (index >= perPage) {
                box.style.display = "none";
            }
            else {
                box.style.display = "";
            }
        })
        if (perPage > activities.length) {
            loadMore?.classList.remove('active')
        }
    })


}

// Function para mostrar mensaje cuando no hay resultados

const showNoResultsMessage = (qtyEl: any) => {
    let msg = document.getElementById('noResults')
    if (qtyEl.length === 0) {
        msg?.classList.add('active')
    } else {
        msg?.classList.remove('active')
    }
}

const enterSearchActivities = () => {
    let searchBtn = document.getElementById('searchBtn')
    document.addEventListener('keypress', (event) => {
        //event.preventDefault()
        let keyCode = event.keyCode ? event.keyCode : event.which;
        if (keyCode === 13) {
            event.preventDefault()
            searchBtn?.click()
        }

    });
}
